<div class="page gray-font-color font-family">
  <div class="header-navigation-back">
    <mat-icon (click)="onNavigateToProfile()">arrow_back</mat-icon>
    <span class="title">Education</span>
    <button
      mat-button
      [disabled]="!form.dirty || (!form.valid && !loading)"
      [class.save-disabled]="!form.dirty || (!form.valid && !loading)"
      class="header-action-button"
      (click)="onSubmit()"
      data-test="save-button"
      >
      Save
    </button>
  </div>
  <div class="content padding-sides-1x">
    <div  class="component-container padding-top-x2">
      @if (errorMessage) {
        <mat-error class="error">
          {{ errorMessage }}
        </mat-error>
      }
      <form [formGroup]="form" (ngSubmit)="onSubmit()" >
        <mat-form-field appearance="outline">
          <mat-label>Highest school grade completed</mat-label>
          <mat-select formControlName="highestGradeCompleted" data-test="highest-school-grade-selector">
            <mat-option value="NoFormalEducation">No formal education</mat-option>
            <mat-option value="PrimaryEducation">Primary education</mat-option>
            <mat-option value="SecondaryEducationHighschool">Secondary education / highschool</mat-option>
            <mat-option value="VocationalQualification">Vocational Qualification</mat-option>
            <mat-option value="Diploma">Diploma</mat-option>
            <mat-option value="BachelorsDegree">Bachelor's degree</mat-option>
            <mat-option value="MastersDegree">Master's degree</mat-option>
            <mat-option value="DoctorateOrHigher">Doctorate or higher</mat-option>
          </mat-select>
          @if (highestGradeCompleted.touched && highestGradeCompleted.invalid) {
            <mat-error>
              {{ getHighestGradeCompletedErrorMessage() }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Last school attended</mat-label>
          <input
            matInput
            formControlName="lastSchoolAttended"
            data-test="last-school-form-field"
            />
          @if (lastSchoolAttended.touched && lastSchoolAttended.invalid) {
            <mat-error>
              {{ getLastSchoolAttendedErrorMessage() }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Type of certificate/diploma</mat-label>
          <input
            matInput
            formControlName="certification"
            data-test="type-of-diploma-form-field"
            />
          @if (certification.touched && certification.invalid) {
            <mat-error>
              {{ getCertificationErrorMessage() }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Special courses or training</mat-label>
          <input
            matInput
            formControlName="specialCourses"
            data-test="special-courses-form-field"
            />
          @if (specialCourses.touched && specialCourses.invalid) {
            <mat-error>
              {{ getSpecialCoursesErrorMessage() }}
            </mat-error>
          }
        </mat-form-field>
      </form>
    </div>
  </div>
</div>
